module.exports = __webpack_public_path__ + "img/logo.fa796c7a.png";